"use client"

import { ResponsiveHeader } from "@/components/responsive-header"

export function PurchaseHeader() {
  return <ResponsiveHeader />
}
